import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { UserService } from '../../../services/user/user';
import { map, catchError, of } from 'rxjs';

// Guard to check if user profile is complete before accessing protected routes
export const profileCompleteGuard: CanActivateFn = () => {
  const userService = inject(UserService);
  const router = inject(Router);

  // If user is already loaded, check synchronously
  if (userService.userLoaded()) {
    if (userService.isProfileComplete()) {
      return true;
    }
    return router.createUrlTree(['/profile']);
  }

  // If user not loaded yet, fetch and then check
  return userService.getCurrentUser().pipe(
    map(() => {
      if (userService.isProfileComplete()) {
        return true;
      }
      return router.createUrlTree(['/profile']);
    }),
    catchError(() => {
      return of(router.createUrlTree(['/profile']));
    })
  );
};
